import React from "react";
import Tooltip from "@mui/material/Tooltip";
import {
  buildMissingFieldsTooltip,
  revealAndScrollToFormField,
} from "../utils/form_required_validation_utils";

export default function FormSubmitButton({
  label,
  resolveMissingFields,
  formRef,
  hardDisabled = false,
  hardDisabledTooltip = "",
  onSubmit,
}) {
  const resolvedMissingFields =
    typeof resolveMissingFields === "function" ? resolveMissingFields() : [];

  const hasMissingRequiredFields = resolvedMissingFields.length > 0;
  const isBlocked = hardDisabled || hasMissingRequiredFields;

  const tooltipText = hardDisabled
    ? hardDisabledTooltip
    : buildMissingFieldsTooltip(resolvedMissingFields);

  const handleClick = () => {
    if (hardDisabled) {
      return;
    }

    const latestMissingFields =
      typeof resolveMissingFields === "function"
        ? resolveMissingFields()
        : [];

    if (latestMissingFields.length > 0) {
      revealAndScrollToFormField({
        formRef,
        field: latestMissingFields[0],
      });
      return;
    }

    onSubmit?.();
  };

  const button = (
    <span
      onClick={handleClick}
      style={{
        cursor: isBlocked ? "not-allowed" : "pointer",
        display: "inline-block",
      }}
    >
      <button
        type="button"
        style={{
          backgroundColor: isBlocked ? "gray" : "#1565C0",
          color: "white",
          border: "0px",
          borderRadius: "5px",
          width: "250px",
          height: "50px",
          pointerEvents: "none",
        }}
      >
        {label}
      </button>
    </span>
  );

  if (!tooltipText) {
    return button;
  }

  return (
    <Tooltip
      title={
        <span style={{ whiteSpace: "pre-line", display: "block" }}>
          {tooltipText}
        </span>
      }
      arrow
      placement="top"
    >
      {button}
    </Tooltip>
  );
}
